// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isWeekend/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isWeekend = convertToFP(fn, 1);
export default isWeekend;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isWeekend/index.js
// module id = 946
// module chunks = 0